import { useState } from "react";
import { successToast, failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { createSendForApprovalReqObj, sendDepositForApproval } from "../api/cashDeposits.service";

export const useSendForApproval = () => {
  const [loading, setLoading] = useState(false);

  const sendForApproval = async (formState, onSuccess = () => {}, onError = () => {}, setState=()=>{}, state) => {
    debugger
    let res={}
    try {

      setLoading(true);
      const reqObj = createSendForApprovalReqObj(formState);
       res = await sendDepositForApproval(reqObj,state);

      if (res?.code === 200) {
        successToast(res?.message || "Sent for approval successfully");
        onSuccess(res?.data);
      } else {
        failureToast(res?.message || "Something went wrong");
        onError(res);
      }
    } catch (err) {
      console.error(err);
      failureToast("Unable to send for approval. Please try again.");
      onError(err);
    } finally {
      res?.state && setState(res?.state);
      setLoading(false);
    }
  };

  return { sendForApproval, loading };
};
